const Images = () =>
    import("@/views/image/Images");

export const ImagesRoute = {
    path: "/images",
    component: Images,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        scope:["aps_broker","aps_executive"],
        breadcrumb: [
            {
                text: "Imágenes",
                disabled: true,
                href: "#"
            },
            {
                text: "Visualización",
                disabled: false,
                href: "#"
            }]
    }
};